// src/components/Footer.jsx
import React from "react";
import logo from "../assets/images/logos/logo.png";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-section bg-lighter rel z-1 mt-0 pt-50">
      <div className="container">
        <div className="row justify-content-center g-4 g-lg-5">
          {/* 1. Logo + descripción — padding extra a la derecha en desktop */}
          <div className="col-12 col-md-6 col-lg-4 mr-lg-10 pr-lg-10"> 
            <img src={logo} height="60" alt="Logotipo Zifit" className="mb-3" />

            {/* margen bottom solo en pantallas < lg */}
            <p className="mb-50 mb-lg-0">
              Zifit ofrece una plataforma para que entrenadores personales
              puedan gestionar las rutinas, dietas y progreso de sus clientes.
            </p>
          </div>

          {/* 2. Empresa */}
          <div className="col-6 col-md-3 col-lg-2">
            <h5 className="footer-title mb-3">Empresa</h5>
            <ul className="list-unstyled footer-links">
              <li><a href="#test">Nosotros</a></li>
              <li><a href="#test">Colaboradores</a></li>
              <li><a href="#test">Últimas Noticias</a></li>
            </ul>
          </div>

          {/* 3. Legal */}
          <div className="col-6 col-md-3 col-lg-2">
            <h5 className="footer-title mb-3">Legal</h5>
            <ul className="list-unstyled footer-links">
              <li><a href="/terminos">Términos y Condiciones</a></li>
              <li><a href="/aviso-legal">Aviso Legal</a></li>
              <li><a href="/privacidad">Política de Privacidad</a></li>
              <li><a href="/cookies">Política de Cookies</a></li>
              <li><a href="/seguridad">Política de Seguridad</a></li>
            </ul>
          </div>

          {/* 4. Contacto */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="footer-title mb-3">Contacto</h5>
            <ul className="list-unstyled footer-links">
              <li><i className="fas fa-map-marker-alt me-2" />Madrid, España</li>
              <li><i className="fas fa-envelope-open me-2" /><a href="mailto:support@zifit.io">support@zifit.io</a></li>
              <li><i className="fas fa-phone me-2" /><a href="tel:+012345678">+012 345 678</a></li>
            </ul>
            <div className="social-style-one mt-3 d-flex gap-3">
              <a href="#test"><i className="fab fa-instagram" /></a>
              <a href="#test"><i className="fab fa-linkedin-in" /></a>
              <a href="#test"><i className="fab fa-twitter" /></a>
              <a href="#test"><i className="fab fa-facebook-f" /></a>
            </div>
          </div>
        </div>

        <p className="text-center border-top pt-3 pb-25 pt-25 mt-25 mb-0">
          © {new Date().getFullYear()} Zifit. Todos los derechos reservados.
        </p>
        
      </div>
    </footer>
  );
}
